const videoRows = document.getElementsByClassName("video-row-inner");

if (videoRows) {
  Array.from(videoRows).forEach((videoRow) => {
    videoRow.addEventListener("wheel", function (event) {
      event.preventDefault();
      const delta = event.deltaY;
      this.scrollLeft -= delta;
    });
  });
}

const main = document.getElementById("main");
if(main) {
  console.log(main.dataset.courseid);
  const courseid = main.dataset.courseid;
  localStorage.setItem("currentC", courseid);
  console.log(localStorage.getItem("currentC"));
}else {
  localStorage.setItem("currentC", "");
}